import { useTheme } from "next-themes";
import { useRouter } from "next/router";
import { ComponentProps, ReactNode, useEffect, useRef, useState } from "react";

export function MixThemeProvider({
    children,
    ...props
}: {
    children: ReactNode;
} & Omit<ComponentProps<"div">, "children">) {
    // During static export prerendering, React context might not be available
    // For extension builds, use a simpler version that doesn't rely on hooks
    if (process.env.BUILD_TARGET === "extension") {
        return <>{children}</>;
    }

    const { resolvedTheme, systemTheme, setTheme } = useTheme();
    const router = useRouter();
    const [mounted, setMounted] = useState(false);
    const previousThemeRef = useRef<string | null>(null);

    useEffect(() => setMounted(true), []);

    const isPaymentsPage = router.pathname.startsWith("/payments/");
    const isPaymentsFormPage = router.asPath.startsWith("/payments/form/");
    const shouldForceLightTheme = isPaymentsPage || isPaymentsFormPage;

    // Ensure the document theme is also light when forcing, then restore
    // useEffect(() => {
    //   if (!mounted) return;
    //   if (shouldForceLightTheme) {
    //     if (resolvedTheme === "dark") {
    //       previousThemeRef.current = "dark";
    //     }
    //     setTheme("light");
    //   } else if (previousThemeRef.current) {
    //     setTheme(previousThemeRef.current);
    //     previousThemeRef.current = null;
    //   }
    //   // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [shouldForceLightTheme, mounted]);

    // During SSR and before hydration, theme is handled by CSS variables
    // CSS variables default to light mode, which prevents hydration mismatch
    return <div {...props}>{children}</div>;
}
